export const smallInputProps = {
  noMarginOnFormGroup: true,
  noPaddingOnFormGroup: true,
  margin: "m-0",
  noBg: true,
  fullWidth: true,
};
